export const preloadedState = {
  "navItems": {
      "brand": {"text": "ERP综合管理系统", "to": "/"},
      "nav": [
        {"text": "首页", "to": "/home" },
        {"text": "产品与服务", "to": "", 
          "subMenu": [
            {"text": "软件开发", "to": ""},
            {"text": "应用集成", "to": ""},
            {"text": "系统运维", "to": ""},
            {"text": "分割线", "to": "divider"},
            {"text": "解决方案", "to": "/solutions"},
            {"text": "管理系统", "to": ""}
          ]
        }
      ],
      "navRight": [
        {"text": "登录", "to": "/login"},
        {"text": "更多", "to": "" , 
          "subMenu": [
            {"text": "帮助文档", "to": "/docs" },
            {"text": "更换设备", "to": "/change-device"},
            {"text": "分割线", "to": "divider"},
            {"text": "文件下载", "to": "/download"},
            {"text": "联系我们", "to": "/contact"}
          ]
        },
      ]
  },
  "products": {},
  "visibilityFilter": "SHOW_ALL",
  "todos": [],
  "warnings": "",
  "welcome": `
    ## ERP综合信息系统 
    `,
  "footer": `#### 立行 | ERP综合信息系统\n` + 
    `Copyright(2017) All Rights Reserved.\n` + 
    `[豫ICP备15009131](http://www.zzlx.org)`
}



// WEBPACK FOOTER //
// ./usr/lib/ui/src/store/preloadedState.js